export default "__VITE_ASSET__BSOJJqtF__"